import Vue from 'vue';

Vue.filter('phone', (phone) => {
  const cleaned = (phone).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{1})?(\d{3})(\d{3})(\d{2})(\d{2})$/);
  if (match) {
    const intlCode = match[1] ? '+7 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4], '-', match[5]].join('');
  }
  return phone;
});

Vue.filter('phoneHref', (phone) => {
  const cleaned = (phone).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{1})?(\d{3})(\d{3})(\d{2})(\d{2})$/);
  if (match) {
    const intlCode = match[1] ? '+7' : '';
    return [intlCode, match[2], match[3], match[4], match[5]].join('');
  }
  return phone;
});
